import { render } from "./NavigationBar.vue?vue&type=template&id=458bc3a6&scoped=true&ts=true"
import script from "./NavigationBar.ts?vue&type=script&lang=ts&external"
export * from "./NavigationBar.ts?vue&type=script&lang=ts&external"

import "./NavigationBar.scss?vue&type=style&index=0&id=458bc3a6&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458bc3a6"]])

export default __exports__